import React, { Component } from 'react';
import './App.css';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { PrivRoute, ScrollToTopItem } from './Components/Items';
import Login from './Pages/LogIn/LogIn';
import RegistroCarrera from './Pages/RegistroCarrera/RegistroCarrera';
import RegistroPago from './Pages/RegistroPago/RegistroPago';
import { message, notification } from 'antd';
import axios from 'axios';
import { login, hasSigned, logout } from "./store/actions/user";
import { connect } from "react-redux";
import Panel from './Pages/Panel/Panel';
import Terminos from './Pages/Terminos/Terminos';
import Politicas from './Pages/Politicas/Politicas';
import PoliticasCancelacion from './Pages/PoliticasCancelacion/PoliticasCancelacion';

class App extends Component {
  state = {
    loading: false,
  }

  async componentDidMount() {
    notification.config({
      placement: 'topRight',
      duration: 30,
    });
    const firstPathname = window.location.pathname

    if (firstPathname === '/logout1') {
      notification.info({
        message: 'Se ha cerrado la sesion por inactividad'
      })
      window.location.replace("/login");
    }
    let cookieEnds
    let cookieEnds2
    axios.interceptors.response.use(async (responsePeticion) => {
      const loggedIn = this.props.isUserLoggedIn
      if (loggedIn) {
        if (cookieEnds !== undefined) {
          clearTimeout(cookieEnds)
        }
        cookieEnds = setTimeout(() => {
          clearTimeout(cookieEnds)
          notification.info({
            message: 'Su sesion se cerrara en 1 minuto si no tiene actividad'
          })
        }, (this.props.tiempoSesion - 60000))
        if (cookieEnds2 !== undefined) {
          clearTimeout(cookieEnds2)
        }
        cookieEnds2 = setTimeout(async () => {
          clearTimeout(cookieEnds2)
          clearTimeout(cookieEnds)
          await this.props.hasSigned().then(async (responseSigned) => {
            if (responseSigned.success === 1) {
            } else {
              this.props.logout().then((responseLogout) => {
                if (responseLogout.success === 1) {
                  window.location.replace("/logout1");
                } else {
                  message.warning(responseLogout.err);
                }
              })
            }
          })
        }, this.props.tiempoSesion)
      }

      //Checar para que no se regrese

      if (Number(responsePeticion?.status) === 204) {
        window.location.replace("/logout1");

      } else if (Number(responsePeticion?.status) === 205) {
        window.location.replace("/panel");
        notification.info({
          message: responsePeticion?.data ? responsePeticion?.data : "No puede utilizar esta empresa por falta de pago"
        })
      } else {
        return responsePeticion;
      }
      // Do something with response data
    }, function (error) {
      // Do something with response error
      return Promise.reject(error);
    });
  }

  render() {
    if (this.state.loading) {
      return null
    }
    return (
      <BrowserRouter>
        {this.state.redirect}
        <ScrollToTopItem />
        <Routes>
          <Route path='/login' element={<Login />} />
          <Route path='/' element={<Navigate to='/registroCarrera' />} />
          <Route path='/registroCarrera' element={<RegistroCarrera />} />
          <Route path='/registroPago' element={<RegistroPago />} />
          <Route path='/terminosYCondiciones' element={<Terminos />} />
          <Route path='/politicaPrivacidad' element={<Politicas />} />
          <Route path='/politicaCancelacion' element={<PoliticasCancelacion />} />
          <Route path='/panel/*' element={<PrivRoute component={Panel} />} />
        </Routes>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isUserLoggedIn: state.user.isUserLoggedIn,
    tiempoSesion: state.user.tiempoSesion,
  };
};

export default connect(mapStateToProps, { login, hasSigned, logout })(App);
